// projectsData.js
import amazonImage from "../assets/amazon/work1.4f6fb9c0eb9b9b31d039.jpg";
import gallery1 from "../assets/amazon/1.png";
import gallery2 from "../assets/amazon/2.png";
import gallery3 from "../assets/amazon/3.png";
import gallery4 from "../assets/amazon/4.png";
import afarImage from "../assets/afar/2.png";
import afarImage1 from "../assets/afar/1.png";
import afarImage2 from "../assets/afar/2.png";
import afarImage3 from "../assets/afar/3.png";
import afarImage4 from "../assets/afar/4.png";
import afarImage5 from "../assets/afar/5.png";
import afarImage6 from "../assets/afar/6.png";
import appleImage from "../assets/apple/m.jpg";
import appleImage1 from "../assets/apple/Screenshot 2024-12-04 043407.png";
import appleImage2 from "../assets/apple/Screenshot 2024-12-04 043429.png";
import appleImage3 from "../assets/apple/Screenshot 2024-12-04 043439.png";
import portfolioCover from "../assets/port/m.png";
import portfolioGallery1 from "../assets/port/Screenshot 2024-12-04 043633.png";
import portfolioGallery2 from "../assets/port/Screenshot 2024-12-04 043653.png";
import portfolioGallery3 from "../assets/port/Screenshot 2024-12-04 043704.png";
import zoomCover from "../assets/zoom/z.jpg";

export const projectsData = [
  {
    id: 1,
    title: "Amazon Clone",
    description: "A fully functional e-commerce platform inspired by Amazon, featuring user authentication, product listings, and order management.",
    image: amazonImage,
    tech: ["React", "Node.js", "MongoDB", "Express", "Firebase"],
    liveUrl: "https://amazonclonekiyaw.netlify.app/",
    subtitle: "Feature-Rich E-Commerce Platform Inspired by Amazon",
    overview: `A comprehensive e-commerce platform built using the MERN stack. The application includes a responsive UI for browsing and purchasing products, a secure backend for managing user data and orders, and real-time authentication using Firebase. Users can search for products, add items to their cart, and complete transactions seamlessly.`,
    challenge: `The primary challenges involved creating a robust product filtering and search system, implementing secure payment gateways, and ensuring scalability to handle a large number of users and transactions.`,
    solution: `We utilized React for a dynamic and responsive user interface, Node.js and Express for backend services, and MongoDB for data storage. Firebase was used for real-time user authentication and database integration. Features like product recommendations and category-based filtering enhance the user experience.`,
    impact: {
      performance: "Ensures seamless navigation and fast load times for all users.",
      scalability: "Supports high user traffic with efficient backend and database optimization.",
      userEngagement: "Enhanced user retention with personalized recommendations and an intuitive UI."
    },
    techStack: {
      frontend: ["React", "Redux", "CSS3", "Bootstrap"],
      backend: ["Node.js", "Express", "MongoDB"],
      authentication: ["Firebase"],
      devops: ["Heroku", "AWS S3"]
    },
    gallery: [gallery4,gallery1, gallery2, gallery3]
  },
  
  
  
  {
    id: 2,
    title: "Afar Region Tourism Bureau Website",
    description: "A full-stack web application designed for the Afar Region Tourism Bureau, featuring content management for news and events, an interactive dashboard, and user-friendly design.",
    image: afarImage,
    tech: ["React", "Node.js", "MongoDB", "Express"],
    liveUrl: "https://afartourismbureau.netlify.app/", // Replace with your actual live project URL
    subtitle: "Comprehensive Tourism Management Platform for the Afar Region",
    overview: `This project is a dynamic and responsive website tailored for the Afar Region Tourism Bureau. It includes a content management system (CMS) for news and event updates, an interactive dashboard for administrators, and a public-facing site that showcases the beauty and culture of the Afar region. The platform facilitates easy updates and ensures an engaging user experience.`,
    challenge: `The primary challenges were designing a flexible CMS to manage diverse content types, integrating user-friendly tools for non-technical administrators, and ensuring the site could handle a growing number of visitors while maintaining optimal performance.`,
    solution: `We implemented a MERN stack-based architecture with React for a responsive user interface and Node.js with Express for backend services. MongoDB was used for managing and organizing the data. The CMS was designed with an intuitive dashboard, allowing administrators to add, edit, and delete news, events, and media content. Advanced caching and server-side rendering were applied to ensure scalability and fast load times.`,
    impact: {
      usability: "Simplified content management for administrators with an intuitive dashboard.",
      accessibility: "Enhanced visibility of the Afar region's tourism potential through a well-designed platform.",
      scalability: "Supports high traffic volumes, ensuring smooth performance during peak periods."
    },
    techStack: {
      frontend: ["React", "Redux", "CSS3", "Bootstrap"],
      backend: ["Node.js", "Express", "MongoDB"],
      authentication: ["JWT"],
      devops: ["Heroku", "AWS S3"]
    },
    gallery: [afarImage,afarImage1,afarImage2,afarImage3,afarImage4,afarImage5,afarImage6]
  },
  
  {
    id: 3,
    title: "Apple Clone",
    description: "A visually stunning frontend clone of the Apple website, showcasing Apple products and services with responsive design and smooth animations.",
    image: appleImage,
    tech: ["React", "CSS3", "JavaScript"],
    liveUrl: "https://apple-frontend.netlify.app", // Replace with your actual live project URL
    subtitle: "Pixel-Perfect Apple Website Clone with Modern UI Features",
    overview: `This project is a frontend clone of the Apple website, built to replicate its sleek design and smooth animations. The clone highlights Apple’s product pages, showcasing devices like iPhones, MacBooks, and Apple Watches. The design focuses on delivering a seamless user experience with responsive layouts, interactive elements, and polished transitions.`,
    challenge: `Recreating Apple’s unique design language required precise attention to detail, including typography, animations, and responsiveness across devices. Ensuring the website remained lightweight and performant despite heavy visuals was also a challenge.`,
    solution: `We utilized React to build reusable components for different sections of the site, ensuring consistency and efficiency. CSS3 animations and transitions were leveraged to mimic the Apple website’s dynamic effects. The design was optimized for performance, with lazy loading of images and minimal external dependencies.`,
    impact: {
      design: "Achieved a pixel-perfect clone of Apple's design with responsive layouts.",
      performance: "Ensured smooth animations and fast loading times with lightweight assets.",
      userExperience: "Delivered an engaging experience that mirrors the official Apple website."
    },
    techStack: {
      frontend: ["React", "CSS3", "JavaScript"],
      animations: ["CSS3 Animations", "GSAP"],
      devops: ["Netlify"]
    },
    gallery: [appleImage, appleImage1, appleImage2, appleImage3]
  },
  
  
  {
    id: 4,
    title: "Portfolio Website",
    description: "A personal portfolio website to showcase projects, skills, and experiences with dynamic animations and responsive design.",
    image: portfolioCover,
    tech: ["React", "Framer Motion", "Styled Components"],
    liveUrl: "https://zekisolomon.netlify.app/", // Replace with the actual live project URL
    subtitle: "Dynamic and Responsive Portfolio Website",
    overview: `This project is a personal portfolio website designed to showcase a developer’s projects, skills, and experiences. Built with React, Framer Motion, and Styled Components, the site features smooth animations, interactive transitions, and a fully responsive layout. The design emphasizes modern aesthetics and usability to engage potential clients and employers.`,
    challenge: `The main challenges were creating fluid and seamless animations while maintaining optimal performance across all devices. Designing a structure that highlights the developer’s achievements and skills in an engaging way was also a key focus.`,
    solution: `React was used for building reusable and modular components, while Framer Motion provided advanced animations and transitions. Styled Components allowed for scoped, maintainable, and flexible styling. The site was designed with responsiveness in mind to ensure compatibility with various screen sizes.`,
    impact: {
      usability: "Provides a user-friendly interface for showcasing projects and skills.",
      aesthetics: "Modern and visually appealing design with engaging animations.",
      performance: "Optimized animations and layout for fast loading and smooth interactions."
    },
    techStack: {
      frontend: ["React", "Framer Motion", "Styled Components"],
      animations: ["Framer Motion"],
      styling: ["Styled Components"],
      devops: ["Netlify"]
    },
    gallery: [portfolioCover, portfolioGallery1, portfolioGallery2, portfolioGallery3]
  }
  ,

  
  {
    id: 5,
    title: "Zoom Clone",
    description: "A real-time video conferencing application with chat functionality, built using EJS, Node.js, and Socket.IO.",
    image: zoomCover,
    tech: ["Node.js", "EJS", "Socket.IO", "PeerJS"],
    liveUrl: "https://github.com/kiyaeh/zoom-clone2", // Replace with the actual live project URL
    subtitle: "Real-Time Video Conferencing Platform",
    overview: `This project is a real-time video conferencing application inspired by Zoom. It includes features like video and audio streaming, text chat, and dynamic room creation. The project uses Socket.IO for real-time communication and PeerJS for seamless peer-to-peer video and audio connections. The application is designed to be lightweight and scalable for efficient group calls.`,
    challenge: `The main challenges were implementing real-time video and audio streams with minimal latency, ensuring stable connections during group calls, and managing communication between multiple users in a scalable manner.`,
    solution: `We utilized Node.js and Express for the backend server and EJS for templating to create a dynamic user interface. Socket.IO enabled real-time chat and room management, while PeerJS handled peer-to-peer video and audio communication. Scalability was ensured through WebRTC optimizations and efficient session handling.`,
    impact: {
      realTimeCommunication: "Facilitated seamless group video calls with low latency.",
      scalability: "Supports multiple users in a single room with optimized performance.",
      usability: "User-friendly interface with intuitive room creation and joining features."
    },
    techStack: {
      frontend: ["EJS", "HTML5", "CSS3", "Bootstrap"],
      backend: ["Node.js", "Express"],
      realTime: ["Socket.IO", "PeerJS", "WebRTC"],
      devops: ["Heroku"]
    },
    gallery: [zoomCover,]
  }
  
    
  ];